<div class="customizer-content" [perfectScrollbar]>
  <!-- Customizer header -->
  <div class="customizer-header px-2 pt-1 pb-0 position-relative">
    <h4 class="mb-0">Personalización</h4>
    <p class="m-0">Configure sus colores de branding</p>
    <!-- 
    <a class="customizer-close" (click)="toggleSidebar('themeCustomizer')"><span [data-feather]="'x'"></span></a> -->
  </div>

  <hr />
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div formGroupName="layout">
      <div id="customizer-styling" class="px-2">
        <!--         <div id="customizer-styling-skin">
          <p class="font-weight-bold">Skin</p>
          <div class="d-flex">
            <div class="custom-control custom-radio mr-1">
              <input
                type="radio"
                id="skinlight"
                formControlName="skin"
                class="custom-control-input layout-name"
                value="default"
              />
              <label class="custom-control-label" for="skinlight">Light</label>
            </div>
            <div class="custom-control custom-radio mr-1">
              <input
                type="radio"
                id="skinbordered"
                formControlName="skin"
                class="custom-control-input layout-name"
                value="bordered"
              />
              <label class="custom-control-label" for="skinbordered">Bordered</label>
            </div>
            <div class="custom-control custom-radio mr-1">
              <input
                type="radio"
                id="skindark"
                formControlName="skin"
                class="custom-control-input layout-name"
                value="dark"
              />
              <label class="custom-control-label" for="skindark">Dark</label>
            </div>
            <div class="custom-control custom-radio" *ngIf="coreConfig.layout.type == 'vertical'">
              <input
                type="radio"
                id="skinsemidark"
                formControlName="skin"
                class="custom-control-input layout-name"
                value="semi-dark"
              />
              <label class="custom-control-label" for="skinsemidark">Semi Dark</label>
            </div>
          </div>
        </div> -->
      </div>

      <!-- 
      <div class="customizer-menu px-2">
        <div id="customizer-menu-type">
          <p class="font-weight-bold">Menu Layout</p>
          <div class="d-flex">
            <div class="custom-control custom-radio mr-1">
              <input
                type="radio"
                id="menu-type-vertical"
                value="vertical"
                formControlName="type"
                class="custom-control-input"
              />
              <label class="custom-control-label" for="menu-type-vertical">Vertical</label>
            </div>
            <div class="custom-control custom-radio mr-1">
              <input
                type="radio"
                id="menu-type-horizontal"
                value="horizontal"
                formControlName="type"
                class="custom-control-input"
              />
              <label class="custom-control-label" for="menu-type-horizontal">Horizontal</label>
            </div>
          </div>
        </div>

        <div
          id="customizer-menu-collapsible"
          class="d-flex mt-2"
          formGroupName="menu"
          *ngIf="coreConfig.layout.type == 'vertical'"
        >
          <p class="font-weight-bold mr-auto m-0">Menu Collapsed</p>
          <div class="custom-control custom-control-primary custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="collapse-sidebar-switch"
              formControlName="collapsed"
            />
            <label class="custom-control-label" for="collapse-sidebar-switch"></label>
          </div>
        </div>

        <div id="customizer-menu-hidden" class="d-flex mt-2" formGroupName="menu">
          <p class="font-weight-bold mr-auto m-0">Menu Hidden</p>
          <div class="custom-control custom-control-primary custom-switch">
            <input type="checkbox" class="custom-control-input" id="collapse-sidebar-hidden" formControlName="hidden" />
            <label class="custom-control-label" for="collapse-sidebar-hidden"></label>
          </div>
        </div>
      </div>
      <hr /> -->

      <!--       <div id="customizer-navbar" class="px-2" formGroupName="navbar">
        <div id="customizer-navbar-colors">
          <p class="font-weight-bold">Color Primario</p>
          <ul class="list-inline unstyled-list">
            <li style="width: 30px; height: 30px;"
              class="color-box bg-white border"
              [ngClass]="{ selected: navbarColorValue === '' }"
              (click)="navbarColor('')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-primary"
              [ngClass]="{ selected: navbarColorValue === 'bg-primary' }"
              (click)="navbarColor('bg-primary')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-secondary"
              [ngClass]="{ selected: navbarColorValue === 'bg-secondary' }"
              (click)="navbarColor('bg-secondary')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-success"
              [ngClass]="{ selected: navbarColorValue === 'bg-success' }"
              (click)="navbarColor('bg-success')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-danger"
              [ngClass]="{ selected: navbarColorValue === 'bg-danger' }"
              (click)="navbarColor('bg-danger')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-info"
              [ngClass]="{ selected: navbarColorValue === 'bg-info' }"
              (click)="navbarColor('bg-info')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-warning"
              [ngClass]="{ selected: navbarColorValue === 'bg-warning' }"
              (click)="navbarColor('bg-warning')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-dark"
              [ngClass]="{ selected: navbarColorValue === 'bg-dark' }"
              (click)="navbarColor('bg-dark')"
            ></li>
          </ul>
        </div>
      </div>
      <hr /> -->

      <div id="customizer-navbar" class="px-2" formGroupName="navbar">
        <div id="customizer-navbar-colors">

          <div class="" style="margin-left: -20px;">
            <div class="col-3 float-left">
              <div class="picker">
                <app-color-picker [color]="primary" [heading]="'Primario'" (event)="setColor('primary', $event)">
                </app-color-picker>
              </div>
            </div>
            <div class="col-3 float-left">
              <div class="picker">
                <app-color-picker [color]="secondary" [heading]="'Secundario'" (event)="setColor('secondary', $event)">
                </app-color-picker>
              </div>
            </div>
            <div class="col-3 float-left">
              <div class="picker">
                <app-color-picker [color]="hoverprimary" [heading]="'Hover Primario'"
                  (event)="setColor('hoverprimary', $event)"></app-color-picker>
              </div>
            </div>
            <div class="col-3 float-left">
              <div class="picker">
                <app-color-picker [color]="hoversecondary" [heading]="'Hover Secundario'"
                  (event)="setColor('hoversecondary', $event)">
                </app-color-picker>
              </div>
            </div>
            <div class="col-3 float-left">
              <div class="picker">
                <app-color-picker [color]="info" [heading]="'Info'" (event)="setColor('info', $event)">
                </app-color-picker>
              </div>
            </div>
            <div class="col-3 float-left">
              <div class="picker">
                <app-color-picker [color]="warning" [heading]="'Alerta'" (event)="setColor('warning', $event)">
                </app-color-picker>
              </div>
            </div>
          </div>
          <!--           <ul class="list-inline unstyled-list">
            <li style="width: 30px; height: 30px;"
              class="color-box bg-white border"
              [ngClass]="{ selected: sidebarColorValue === '' }"
              (click)="sidebarColor('#ffffff')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-primary"
              [ngClass]="{ selected: sidebarColorValue === '#00377D' }"
              (click)="sidebarColor('#00377D')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-secondary"
              [ngClass]="{ selected: sidebarColorValue === '#00C8FF' }"
              (click)="sidebarColor('#00C8FF')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-success"
              [ngClass]="{ selected: sidebarColorValue === '#37C846' }"
              (click)="sidebarColor('#37C846')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-danger"
              [ngClass]="{ selected: sidebarColorValue === '#F01E46' }"
              (click)="sidebarColor('#F01E46')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-info"
              [ngClass]="{ selected: sidebarColorValue === '#3264DC' }"
              (click)="sidebarColor('#3264DC')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-warning"
              [ngClass]="{ selected: sidebarColorValue === '#ffaa32' }"
              (click)="sidebarColor('#ffaa32')"
            ></li>
            <li style="width: 30px; height: 30px;"
              class="color-box bg-dark"
              [ngClass]="{ selected: sidebarColorValue === '#c0c0c0' }"
              (click)="sidebarColor('#c0c0c0')"
            ></li>
          </ul> -->
        </div>

      </div>
      <!-- 
      <div id="customizer-footer" class="px-2 mb-2" formGroupName="footer">
        <div id="customizer-footer-type">
          <p class="font-weight-bold">Footer Type</p>
          <div class="d-flex">
            <div class="custom-control custom-radio mr-1">
              <input
                type="radio"
                id="footer-type-sticky"
                value="footer-sticky"
                formControlName="type"
                class="custom-control-input"
              />
              <label class="custom-control-label" for="footer-type-sticky">Sticky</label>
            </div>
            <div class="custom-control custom-radio mr-1">
              <input
                type="radio"
                id="footer-type-static"
                value="footer-static"
                formControlName="type"
                class="custom-control-input"
              />
              <label class="custom-control-label" for="footer-type-static">Static</label>
            </div>
            <div class="custom-control custom-radio mr-1">
              <input
                type="radio"
                id="footer-type-hidden"
                value="d-none"
                formControlName="type"
                class="custom-control-input"
              />
              <label class="custom-control-label" for="footer-type-hidden">Hidden</label>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div style="clear: both;"></div>
    <div class="col-12 mt-2">
      <button type="submit" class="btn btn-primary mr-1 mt-1">Guardar Cambios</button>
      <button class="btn btn-outline-secondary mt-1">Cancelar</button>
    </div>
  </form>
</div>
